import { render, staticRenderFns } from "./ReleaseRecord.vue?vue&type=template&id=6c5e0de2&scoped=true"
import script from "./ReleaseRecord.vue?vue&type=script&lang=js"
export * from "./ReleaseRecord.vue?vue&type=script&lang=js"
import style0 from "./ReleaseRecord.vue?vue&type=style&index=0&id=6c5e0de2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5e0de2",
  null
  
)

export default component.exports